import React, { useState } from "react";
import { Plus, X, Sprout } from "lucide-react";
import { INGREDIENTES } from "@/content";
import Reveal from "@/components/Reveal";

export default function Ingredientes() {
  const [abierto, setAbierto] = useState(null);

  return (
    <section
      className="py-16 md:py-24"
      style={{ background: "var(--lima-soft)" }}
      data-testid="section-ingredientes"
    >
      <div className="container-page">
        <Reveal className="text-center">
          <span className="chip" style={{ background: "var(--blanco)" }}>
            <Sprout size={15} strokeWidth={2} aria-hidden="true" />
            Fórmula FuXion
          </span>
          <h2 className="h2-display mt-5 mx-auto max-w-[18ch] md:max-w-none" style={{ color: "var(--vino)" }}>
            {INGREDIENTES.h2a}{" "}
            <span className="block md:inline" style={{ color: "var(--vino)" }}>
              Ninguno inventado en un{" "}
              <span style={{ color: "#5d8a1f" }}>laboratorio.</span>
            </span>
          </h2>
          <p className="mt-3 text-[14px]" style={{ color: "var(--gris)" }}>
            {INGREDIENTES.hint}
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5">
          {INGREDIENTES.items.map((ing, i) => {
            const open = abierto === i;
            return (
              <Reveal key={ing.nombre} delay={(i % 3) * 80}>
                <button
                  type="button"
                  onClick={() => setAbierto(open ? null : i)}
                  aria-expanded={open}
                  data-testid={`ingrediente-${i}`}
                  className="w-full h-full text-center p-4 md:p-6 transition-all duration-300 relative"
                  style={{
                    background: "var(--blanco)",
                    borderRadius: 24,
                    border: open ? "2px solid var(--lima)" : "2px solid transparent",
                    boxShadow: open ? "var(--shadow-mid)" : "var(--shadow-soft)",
                    cursor: "pointer",
                  }}
                >
                  <span
                    className="absolute flex items-center justify-center rounded-full"
                    style={{
                      top: 12,
                      right: 12,
                      width: 26,
                      height: 26,
                      background: open ? "var(--lima)" : "var(--lima-soft)",
                    }}
                    aria-hidden="true"
                  >
                    {open ? (
                      <X size={14} strokeWidth={3} color="#fff" />
                    ) : (
                      <Plus size={14} strokeWidth={3} style={{ color: "var(--vino)" }} />
                    )}
                  </span>

                  <img
                    src={ing.img}
                    alt={ing.nombre}
                    loading="lazy"
                    className="mx-auto rounded-full object-cover"
                    style={{
                      width: 78,
                      height: 78,
                      boxShadow: "0 10px 24px rgba(107,31,58,0.16)",
                      border: "3px solid #fff",
                    }}
                  />
                  <h3
                    className="font-display mt-4"
                    style={{ fontSize: 18, color: "var(--vino)", lineHeight: 1.15 }}
                  >
                    {ing.nombre}
                  </h3>
                  <p
                    className="mt-2 text-[14px] leading-snug"
                    style={{ color: "var(--gris)" }}
                  >
                    {ing.linea}
                  </p>
                  <div
                    className="overflow-hidden transition-all duration-400"
                    style={{
                      maxHeight: open ? 220 : 0,
                      opacity: open ? 1 : 0,
                      transitionDuration: "400ms",
                    }}
                  >
                    <p
                      className="mt-3 pt-3 text-[13px] leading-relaxed"
                      style={{
                        color: "var(--carbon)",
                        borderTop: "1px solid rgba(139,197,63,0.4)",
                      }}
                    >
                      {ing.detalle}
                    </p>
                  </div>
                </button>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
